import JSZip from 'jszip'
import JSZipUtils from 'jszip-utils'
import FileSaver from 'file-saver'

const urlToPromise = (url) => {
  return new Promise((resolve, reject) => {
    JSZipUtils.getBinaryContent(url, (err, data) => {
      if (err) reject(err)
      else resolve(data)
    })
  })
}

const getExtension = (file) => {
  return file.url.split('.').reverse()[0]
}

export const downloadZip = async (files, name) => {
  const zip = new JSZip()
  for (const index in files) {
    const file = files[index]
    const binary = await urlToPromise(file.url)
    const extension = getExtension(file);
    const filename = `${index}.${extension}`
    zip.file(filename, binary, { binary: true })
  }
  await zip.generateAsync({ type: 'blob' })
    .then((blob) => {
      FileSaver.saveAs(blob, `${name}.zip`)
    })
}
